module.exports = __webpack_public_path__ + "static/flags/IR-e7bc1d593ea4988f1bd498c89100e2fc.gif";